import { render, staticRenderFns } from "./MenuHorizontal.vue?vue&type=template&id=15b23340&scoped=true&"
import script from "./MenuHorizontal.vue?vue&type=script&lang=js&"
export * from "./MenuHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./MenuHorizontal.vue?vue&type=style&index=0&id=15b23340&scoped=true&lang=css&"
import style1 from "./MenuHorizontal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b23340",
  null
  
)

export default component.exports